import { createNamedStub } from "../../demo/stubHelpers";
import { asDemoLocale } from "../../demo/demoLocale";
import { mockDeliveries } from "../../demo/mockShopListings";

const deliveryServices = {
  get: async (_academyId: string) => asDemoLocale(mockDeliveries),
  addPhysical: createNamedStub({}),
  addDigital: createNamedStub({}),
  update: createNamedStub({}),
  remove: createNamedStub({}),
};

export default deliveryServices;
